import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ApartmentsDetailsBasicElement from '@/features/apartments/components/ApartmentsDetails/Basic/ApartmentsDetailsBasicElement';
import LocationIcon from '@/components/icons/LocationIcon';
import ArrowExpandIcon from '@/components/icons/ArrowExpandIcon';
import IdeaIcon from '@/components/icons/IdeaIcon';
import DropletIcon from '@/components/icons/DropletIcon';
import FireIcon from '@/components/icons/FireIcon';
import InternetIcon from '@/components/icons/InternetIcon';
import { cn } from '@/lib/utils';

type Props = {
	cadastralCode?: string;
	squareness: number;
	electricityId?: string;
	waterId?: string;
	gasId?: string;
	internetId?: string;
	isMobile?: boolean;
};

const ApartmentsDetailsBasic: FC<Props> = ({
	cadastralCode,
	squareness,
	electricityId,
	waterId,
	gasId,
	internetId,
	isMobile,
}) => {
	const { t } = useTranslation();

	return (
		<div className='flex flex-col gap-4 select-none'>
			<div className='flex gap-2'>
				<h3 className={cn(isMobile && 'text-base')}>
					{t('main.apartments.components.details.list.basic.title')}
				</h3>
			</div>
			<div
				className={cn(
					'p-6 flex flex-col gap-4 border border-popover-100 rounded-2.5xl bg-popover-10 text-sm',
					isMobile && 'p-0 border-0 bg-popover-30',
				)}>
				<div className='flex flex-col gap-2'>
					<h5
						className={cn(
							'text-popover-800',
							isMobile && 'text-sm',
						)}>
						{t(
							'main.apartments.components.details.list.basic.elements.general.title',
						)}
					</h5>
					<div className='flex flex-col gap-2'>
						<ApartmentsDetailsBasicElement
							label={t(
								'main.apartments.components.details.list.basic.elements.general.items.cadastralCode',
							)}
							value={cadastralCode || ''}
							icon={LocationIcon}
						/>
						<ApartmentsDetailsBasicElement
							label={t(
								'main.apartments.components.details.list.basic.elements.general.items.squareness',
							)}
							value={`${squareness}`}
							icon={ArrowExpandIcon}
							unit={'m²'}
						/>
					</div>
				</div>
				<div className='flex flex-col gap-2'>
					<h5
						className={cn(
							'text-popover-800',
							isMobile && 'text-sm',
						)}>
						{t(
							'main.apartments.components.details.list.basic.elements.utilities.title',
						)}
					</h5>
					<div className='flex flex-col gap-2'>
						<ApartmentsDetailsBasicElement
							label={t(
								'main.apartments.components.details.list.basic.elements.utilities.items.electricityID',
							)}
							value={electricityId || ''}
							icon={IdeaIcon}
						/>
						<ApartmentsDetailsBasicElement
							label={t(
								'main.apartments.components.details.list.basic.elements.utilities.items.waterID',
							)}
							value={waterId || ''}
							icon={DropletIcon}
						/>
						<ApartmentsDetailsBasicElement
							label={t(
								'main.apartments.components.details.list.basic.elements.utilities.items.gasID',
							)}
							value={gasId || ''}
							icon={FireIcon}
						/>
						<ApartmentsDetailsBasicElement
							label={t(
								'main.apartments.components.details.list.basic.elements.utilities.items.internetID',
							)}
							value={internetId || ''}
							icon={InternetIcon}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ApartmentsDetailsBasic;
